var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-white", attrs: { flat: _vm.page_feed } },
    [
      !_vm.page_feed
        ? _c(
            "q-card-title",
            { staticClass: "text-center bg-primary text-white" },
            [_vm._v("\n        " + _vm._s(_vm.$t(_vm.title_feed)) + "\n    ")]
          )
        : _vm._e(),
      !_vm.page_feed ? _c("q-card-separator") : _vm._e(),
      _c(
        "q-card-main",
        {
          staticClass: "text-center relative-position",
          style: _vm.home ? "" : "min-height: 70vh"
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "", separator: "", link: "" } },
            _vm._l(_vm.filteredActivities, function(activity, index) {
              return _c(
                "q-item",
                {
                  key: index,
                  staticClass: "q-py-lg q-px-none ",
                  nativeOn: {
                    click: function($event) {
                      return _vm.openActivity(activity)
                    }
                  }
                },
                [
                  _vm.$q.platform.is.desktop && !_vm.home
                    ? _c(
                        "q-item-side",
                        { staticClass: "image-activity-desktop" },
                        [
                          activity.im
                            ? _c("img", {
                                attrs: { src: _vm.getImageUrl(activity.im) }
                              })
                            : _vm._e(),
                          !activity.im
                            ? _c("img", {
                                attrs: { src: _vm.getPlaceholder(activity) }
                              })
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "q-item-main",
                    { attrs: { "label-lines": "1", "sublabel-lines": "2" } },
                    [
                      _vm.$q.platform.is.mobile || _vm.home
                        ? _c(
                            "div",
                            {
                              staticClass: "text-center q-mb-sm",
                              class:
                                activity.s == "bu"
                                  ? "image-activity-mobile-badge"
                                  : "image-activity-mobile"
                            },
                            [
                              activity.im
                                ? _c("img", {
                                    attrs: { src: _vm.getImageUrl(activity.im) }
                                  })
                                : _vm._e(),
                              !activity.im
                                ? _c("img", {
                                    attrs: { src: _vm.getPlaceholder(activity) }
                                  })
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm.$q.platform.is.mobile
                        ? _c(
                            "q-item-tile",
                            { staticClass: "text-faded q-mb-md" },
                            [
                              _c("timeago", {
                                attrs: {
                                  datetime: activity.d,
                                  "auto-update": 60
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getActivityDescription(activity)
                            )
                          }
                        })
                      ]),
                      _vm.$q.platform.is.desktop
                        ? _c("q-item-tile", { staticClass: "text-faded" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getTimeAgo(activity.d)) +
                                "\n                    "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _c(
            "q-inner-loading",
            { attrs: { visible: _vm.timeline.length == 0 } },
            [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }